import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        try {
            const res = await api.get("/auth/me");
            setUser(res.data);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // Skip /me check when processing OAuth callbacks (avoid race condition)
        const isLegacyOAuth = window.location.hash?.includes("session_id=");
        const isGoogleOAuth = window.location.pathname === "/cont" &&
            new URLSearchParams(window.location.search).get("code");
        if (isLegacyOAuth || isGoogleOAuth) {
            setLoading(false);
            return;
        }
        checkAuth();
    }, [checkAuth]);

    const login = async (email, password) => {
        const res = await api.post("/auth/login", { email, password });
        localStorage.setItem("st_token", res.data.token);
        setUser(res.data.user);
        return res.data.user;
    };

    const register = async (data) => {
        const res = await api.post("/auth/register", data);
        localStorage.setItem("st_token", res.data.token);
        setUser(res.data.user);
        return res.data.user;
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch {}
        localStorage.removeItem("st_token");
        setUser(null);
    };

    const isAdmin = user && (user.role === "superadmin" || user.role === "admin");
    const isStaff = user && ["superadmin", "admin", "sales", "installer"].includes(user.role);

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, checkAuth, isAdmin, isStaff }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
